import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CalendarCultivationHierarchyListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-hierarchy-list.response';
import { CalendarCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-list.response';
import { SkeletonLoaderComponent } from '../../../@commons/@components/loaders/skeleton-loader/skeleton-loader.component';
import { ErrorStateComponent } from '../../../@commons/ui-components/error-state/error-state.component';
import { CalendarHierarchyCardComponent } from './calendar-hierarchy-card/calendar-hierarchy-card.component';
import { CalendarBadge } from './calendar-hierarchy-card/calendar-hierarchy-card-item/calendar-hierarchy-card-item.component';
import { dayPosition } from '../../../@commons/@services/front/period-bars.util';

/**
 * La liste du calendrier : une carte par culture ou par famille, serrées les
 * unes sous les autres, traversées d'un seul trait vertical au jour
 * d'aujourd'hui. L'en-tête collant (recherche, filtres, axe des mois) vit
 * au-dessus, dans la page.
 *
 * Le chargement garde la place des lignes ; une panne se dit dans la carte,
 * l'en-tête reste intact (R7).
 */
@Component({
  selector: 'vw-calendar-hierarchies',
  imports: [CalendarHierarchyCardComponent, SkeletonLoaderComponent, ErrorStateComponent],
  templateUrl: './calendar-hierarchies.component.html',
  styleUrls: ['./calendar-hierarchies.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CalendarHierarchiesComponent {
  @Input() hierarchies: CalendarCultivationHierarchyListResponse[] = [];
  @Input() isLoading: boolean = true;
  @Input() loadError: boolean = false;
  @Input() badgeOf: (cultivationUid: string) => CalendarBadge = () => null;
  @Output() cultivationSelected: EventEmitter<CalendarCultivationListResponse> = new EventEmitter();
  @Output() retry = new EventEmitter<void>();

  /** Le trait d'aujourd'hui, en % de la grille des mois, au jour près comme les barres. */
  readonly todayLeft = (dayPosition(new Date()) / 12) * 100;

  onCultivationSelected(cultivation: CalendarCultivationListResponse) {
    this.cultivationSelected.emit(cultivation);
  }
}
